import React, { useCallback, useEffect } from 'react';
import useResourcesStore from '@monorepo/shared/src/graph/state/query-hooks/use-resources';
import useResources from '@monorepo/shared/src/hooks/use-resources';
import ResourcesList from '@monorepo/shared/src/components/modules/Resources/ResourcesList';

type Props = {
  letter: string;
};

const LetterResources: React.FC<Props> = ({ letter }) => {
  const [resourceStore] = useResourcesStore(letter);
  const [{ resources }, { setResources }] = useResources();

  const handleOnPinClick = useCallback(() => null, []);

  useEffect(() => {
    setResources(resourceStore.resources);
  }, [resourceStore.isLoading]);

  const data = resources;

  return (
    <ResourcesList
      resources={data}
      onPinClick={handleOnPinClick}
      areDisplayingCardHeaders={false}
    />
  );
};

export default LetterResources;
